import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetProfilesMutation } from '../../../api/AdminProfileAPI';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { IAuftraggeber, IProfileDto } from '../../../types/Types';
import { useGetAuftraggeberListeMutation, useGetAuftraggeberMutation } from '../../../api/StammdatenAPI';

export default function AuftraggeberMain() {

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IAuftraggeber[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [getAuftraggeberListeAPI] = useGetAuftraggeberListeMutation();

  const init = () => {
    getAuftraggeberListeAPI().unwrap()
      .then(data => setListe(data))
      .then(() => setLoaded(true))
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Auftraggeber</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>
          {
            (isLoaded && liste?.map((e, index) =>
              <div key={index} className={styles["wg-div-row"]}>
                <div>{e.name}</div>
                <div style={{ textAlign: "end" }}>
                  <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                </div>
              </div>)
            )
          }
          {(!isLoaded && <>Lädt...</>)}
        </div>
      </div>

    </>
  );
}